import { AuthGuard } from './guards/auth.guard';

export { AuthGuard } from './guards/auth.guard';

export const GUARDS: any[] = [
	AuthGuard
];
